// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27aS3","left":"styles_left__1vkR7"};